/** @format */

export const dataExperience = {
  list: {
    0: {
      main: "Software Developer",
    },
    1: {
      main: "Solution Engineer",
    },
    2: {
      main: "Software Developer",
    },
    3: {
      main: "Software Engineer",
    },
  },
  info: {
     0: {
      title: "ePlannerPro 🏢",
      date: "Jan 2025 - Present",
      first: "Developing robust and scalable RESTful APIs using ASP.NET Core and NestJS, enhancing backend architecture and data handling efficiency.",
      second: "Building dynamic and responsive frontend applications with Angular, focusing on modular design and optimal user experience",
      third: "Set up CI/CD pipelines with Azure App Services to automate build, test, and deployment processes, improving release speed and reliability.",
    },
    1: {
      title: "IndoWorld Consulting & Technology Services Pvt. Ltd. 🏢",
      date: "Aug 2023 - Dec 2024",
      first: "Designed and implemented RESTful APIs using ASP.NET Core Web API, ensuring seamless integration with frontend services.",
      second: "Built responsive and scalable web applications using Angular, HTML5, CSS3, and TypeScript, optimizing user experience and performance.",
      third: "Created reusable component libraries in React with Redux Toolkit, improving development efficiency.",
    },
   2: {
      title: "ekZero Enterprise Software Services Pvt. Ltd. 🏢",
      date: "Sept 2022 - Aug 2023",
      first: "Successfully integrated RESTful APIs into Angular applications, streamlining data flow between backend and frontend systems.",
      second: "Designed secure API endpoints using ASP.NET Core Web API for payment processing systems.",
      third: "Built responsive UI components using modern CSS frameworks (SCSS, Bootstrap) and jQuery.",
    },
   3: {
      title: "Helios Solutions 🏢",
      date: "Dec 2020 - Aug 2022",
      first: "Integrated REST APIs for frontend development using technologies like Angular, HTML5, CSS3 and JavaScript.",
      second: "Implemented responsive design patterns ensuring cross-browser compatibility.",
      third: "Optimized user interfaces using Bootstrap and SCSS, resulting in improved user engagement.",
    },
  },
};

export const dataEducation = {
  0: {
    main: "IGNOU🎓",
    expand: "Master of Computer Applications",
    date: "( 2021 / 2023 )",
    country: "CGPA:",
  },
  1: {
    main: "North Maharashtra University🎓",
    expand: "Bachelor in Computer Application",
    date: "( 2017 / 2020 )",
    country: "CGPA: 9.07",
  },
  2: {
    main: "S. T. Gujar Jr. College 🎓",
    expand: "Science (Senior Secondary School)",
    date: "( 2014 / 2016 )",
    country: "58.92%",
  },
};
